import React, {useEffect, useState} from 'react'
// import {KTIcon} from '../../../_metronic/helpers'
import {cardData} from './helper'
import {getAllUser, getEnterprises, getAddOnEnquiry} from '../../../api'
import SkeletonCard from '../Auth/Components/SkeletonCard'

interface ApiResponse {
  all_users: number
  web_users: number
  mobile_users: number
  farms: number
  paid_farms: number
  active_web_users: number
  active_mobile_users: number
  enterprises: number
  enterprise_users: number
  enterprise_farms: number
  total_farm_area: any
  unpaid_farms: number
  active_users: number
  not_active_users: number
  farmers_with_paid_farms: number
  farmers_with_unpaid_farms: number
}

interface EnterpriseApiResponse {
  total_enterprise: number
}

// interface EnquiryApiResponse {
//   total_enquiries: number
// }

function Card({
  type,
  onEnquiryCountUpdate,
}: {
  type: string
  onEnquiryCountUpdate?: (count: number) => void
}) {
  const [apiData, setApiData] = useState<ApiResponse | null>(null)
  const [enquiryCount, setEnquiryCount] = useState<number>(0)
  const [enterpriseCount, setEnterpriseCount] = useState<EnterpriseApiResponse | null>(null)
  const [loadingUsers, setLoadingUsers] = useState(true)
  const [loadingEnterprises, setLoadingEnterprises] = useState(true)
  const [loadingEnquiries, setLoadingEnquiries] = useState(true)

  useEffect(() => {
    const fetchUsersAndEnterprises = async () => {
      console.log("Fetching users and enterprises...");
      try {
        const [users, enterprises] = await Promise.all([getAllUser(), getEnterprises()])
        console.log("FetchedUsers", users);
        console.log("FetchedEnterprises", enterprises);
        setApiData(users)
        setEnterpriseCount(enterprises)
      } catch (error) {
        console.error('Error fetching users or enterprises:', error)
      } finally {
        setLoadingUsers(false)
        setLoadingEnterprises(false)
      }
    }

    fetchUsersAndEnterprises()
  }, [])

  useEffect(() => {
    const fetchEnquiryCount = async () => {
      try {
        const enquiries = await getAddOnEnquiry()
        setEnquiryCount(enquiries.enquiries_count)
        if (onEnquiryCountUpdate) {
          onEnquiryCountUpdate(enquiries.enquiries_count) // Call only if defined
        }
      } catch (error) {
        console.error('Error fetching enquiries:', error)
      } finally {
        setLoadingEnquiries(false)
      }
    }

    fetchEnquiryCount()
  }, [onEnquiryCountUpdate])

  const updatedCardData = cardData.map((card) => {
    switch (card.label) {
      case 'All Users':
        card.count = apiData?.all_users || 0
        card.loading = loadingUsers
        break
      case 'Web Users':
        card.count = apiData?.web_users || 0
        card.loading = loadingUsers
        break
      case 'Active Web Users logged in within 30 days':
        card.count = apiData?.active_web_users || 0
        card.loading = loadingUsers
        break
      case 'Mobile Users':
        card.count = apiData?.mobile_users || 0
        card.loading = loadingUsers
        break
      case 'Active Mobile Users logged in within 30 days':
        card.count = apiData?.active_mobile_users || 0
        card.loading = loadingUsers
        break
      case 'Total Enterprises':
        card.count = apiData?.enterprises || 0
        card.loading = loadingUsers
        break
      case 'Enterprise Users':
        card.count = apiData?.enterprise_users || 0
        card.loading = loadingUsers
        break
      case 'Total Farms':
        card.count = apiData?.farms || 0
        card.loading = loadingUsers
        break
      case 'Total Paid Farms':
        card.count = apiData?.paid_farms || 0
        card.loading = loadingUsers
        break
      case 'Total Unpaid Farms':
        card.count = apiData?.unpaid_farms || 0
        card.loading =loadingUsers
        break
      case 'Total Active Users':
        card.count = apiData?.active_users || 0
        card.loading = loadingUsers
        break
      case 'Total Inactive Users':
        card.count = apiData?.not_active_users || 0
        card.loading = loadingUsers
        break
      case 'Total Paid Users':
        card.count = apiData?.farmers_with_paid_farms || 0
        card.loading = loadingUsers
        break
      case 'Total Unpaid Users':
        card.count = apiData?.farmers_with_unpaid_farms || 0
        card.loading = loadingUsers
        break
      case 'Total Farm Area':
        card.count =
          apiData?.total_farm_area !== undefined
            ? parseFloat(apiData.total_farm_area.toFixed(2))
            : 0
        card.loading = loadingUsers
        break
      case 'Total Enquiries':
        card.count = enquiryCount || 0
        card.loading = loadingEnquiries
        break
      default:
        break
    }
    return card
  })

  const filteredData = updatedCardData.filter((card) => card.type.includes(type))

  return (
    <div className='row row-cols-1 row-cols-md-5 g-3 g-xl-3 mb-2 mt-1'>
      {filteredData.map((card) => (
        <div className='col' key={card.id}>
          {/* Card */}
          {card.loading ? (
            <SkeletonCard />
          ) : (
            <div
              className='card hoverable card-xl-stretch h-100'
              style={{backgroundColor: card.bgcolor}}
            >
              <div className='p-3 d-flex items-start'>
                <img
                  src={card.icon}
                  alt='icon'
                  className='fs-1 text-black me-4'
                  style={{width: '24px', height: '24px'}}
                />
                <div>
                  <div className='fw-semibold text-gray-800'>{card.label}</div>
                  <div className='text-black fw-bold fs-2'>
                    {card.label === 'Total Farm Area' ? `${card.count} (ac)` : card.count}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default Card
